module.exports = __webpack_public_path__ + "static/media/bgaming.9fc46204.jpeg";